var changePasswordCtrl = function (restSvc, ifacsSvc, iFastWebContextRootSvc, $rootScope, $location, $cookies, loginLocation, $analytics, changePasswordConstant,$modal,showPasswordChangeConfirmation) {
    "use strict";

    this.changePwdConstant = changePasswordConstant;

    this[this.changePwdConstant.JUSERNAME] = undefined;
    this[this.changePwdConstant.JPASSWORD] = undefined;
    this[this.changePwdConstant.NEWPASSWORD] = undefined;
    this[this.changePwdConstant.CONFPASSWORD] = undefined;
    this.beforeLogin = true;
    this.restSvc = restSvc;
    this.ifacsSvc = ifacsSvc;
    this.iFastWebContextRootSvc = iFastWebContextRootSvc;
    this.rootScope = $rootScope;
    this.location = $location;
    this.cookies = $cookies;
    this.loginLocation = loginLocation;
    this.modal=$modal;
    this.showPasswordChangeConfirmation=showPasswordChangeConfirmation;
    this.analytics = $analytics;
    this.isOldPasswordNotCorrect=true;
    this.onLoad();
    
};

changePasswordCtrl.prototype.onLoad = function () {
    "use strict";

    var clientCd = this.iFastWebContextRootSvc.clientCode;
    this.isChangingPasswordSubmitted = false;
    this[this.changePwdConstant.JUSERNAME] = this.cookies.get(this.changePwdConstant.JUSERNAME);
	this.isPassWordValid = false;
	this.isNewPasswdInputFocussed = false;	
    this.onUsernamePwdChange();
    var rest = this.restSvc.query({type: "configuration", method: "retrieveChangePwdSetting"}, {"clientCd" : clientCd});
    rest.$promise.then(this.pass(this),this.fail);
};
changePasswordCtrl.prototype.doValidatePwd = function () {
    "use strict";
    this.ifacsSvc.changePwd({ method:"validate_pwd"},
        {j_username: this.j_username, j_password : this.j_password,
         new_password : this.new_password})
        .$promise.then(this.passValidatePwd(this));
};

changePasswordCtrl.prototype.doValidateOldPwd = function () {
    "use strict";
    if(!!!this.j_password){
    	return;
    }
    this.ifacsSvc.changePwd({ method:"validate_oldpwd"},
        {j_username: this.j_username, 
    	 j_password : this.j_password,
         new_password : "abc",
         tknlgn: this.cookies.get('tknlgn')})
        .$promise.then(this.passValidateOldPwd(this));
        
    
};

changePasswordCtrl.prototype.passValidatePwd = function (controller) {
    "use strict";
    console.log("New Password is submitted to validate the password Rule.");
    return function(response) {
        var responseCode = response.code;
        console.log("Response from ifacs:" + responseCode);
        controller.isPassWordValid = ("SUCCESS" === responseCode?true:false);
    };
};

changePasswordCtrl.prototype.passValidateOldPwd = function (controller) {
    "use strict";
    window.console.log("New Password is submitted to validate the password Rule.");
    return function(response) {
        var responseCode = response.code;
        window.console.log("Response from ifacs:" + responseCode);
        
        controller.changePwdResponse = controller.changePwdResponseMap[responseCode];
        controller.isOldPasswordNotCorrect = ("SUCCESS" === responseCode?false:true);
        controller.isChangingPasswordSubmitted= ("SUCCESS" === responseCode?false:true);
    };
};

changePasswordCtrl.prototype.onUsernamePwdFocus = function () {
    "use strict";
	this.isNewPasswdInputFocussed = true;
};
changePasswordCtrl.prototype.pass = function (controller){
    "use strict";
    return function (result) {
        controller.userAdminSettingMap = result.userAdminSettingMap;
        controller.changePwdResponseMap = result.changePwdResponseMap;
        controller.getLabel = function (fieldName) {
            return controller.userAdminSettingMap[fieldName];
        };
        
    };

};




changePasswordCtrl.prototype.onSubmit = function () {
    "use strict";

    // track analytics
    this.analytics.eventTrack("ChangePassword",{
        "usernameValue": this[this.changePwdConstant.JUSERNAME],
        "usernameText":this[this.changePwdConstant.JUSERNAME],
        "usernameFieldName":"submit",
        "usernameObjectName":"UserAdminSetting",
        "usernameModule":"UserAdminSetting"
    });


    this.ifacsSvc.changePwd({ method:"change_pwd"},
        {"j_username": this[this.changePwdConstant.JUSERNAME], "j_password" : this[this.changePwdConstant.JPASSWORD],
         "new_password" : this[this.changePwdConstant.NEWPASSWORD], "conf_password" : this[this.changePwdConstant.CONFPASSWORD]})
        .$promise.then(this.passChangePwd(this));
};

changePasswordCtrl.prototype.passChangePwd = function (controller) {
    "use strict";

    window.console.log("Change password request is submitted.");

    return function(response) {
        var responseCode = response.code;
        window.console.log("Response from ifacs:" + responseCode);
        controller.isChangingPasswordSubmitted = true;
        controller.changePwdResponse = controller.changePwdResponseMap[responseCode];
        if ("SUCCESS" === responseCode) {
            var redirectUrl = controller.userAdminSettingMap.changePwdRedirectUrl;
            window.console.log("redirectUrl=" + redirectUrl);
            if (redirectUrl) {
                redirectUrl = redirectUrl.trim();
                if (0 < redirectUrl.length) {
                	controller.redirectUrl=redirectUrl;
                }
                redirectUrl = redirectUrl + (redirectUrl.indexOf("?")>0?"&pcs=yes":"?pcs=yes");
                controller.loginLocation.url(redirectUrl);
            }else
			{
				controller.loginLocation.url("/login?pcs=yes");
			}
        }
    };
};

changePasswordCtrl.prototype.onCancel = function () {
    "use strict";
    this.loginLocation.url("/login");
};

changePasswordCtrl.prototype.onUsernamePwdChange = function () {
    "use strict";
	
	this.doValidatePwd();
    if (null != this.j_username && 0 < this.j_username.trim().length &&
        null != this.j_password && 0 < this.j_password.length &&
        null != this.new_password && 0 < this.new_password.length &&
        null != this.conf_password && 0 < this.conf_password.length) {
        this.disableSubmit = false;
    } else {
        this.disableSubmit = true;
    }
};

changePasswordCtrl.$inject = ["restSvc", "ifacsSvc", "iFastWebContextRootSvc", "$rootScope", "$location", "$cookies", "loginLocation", "$analytics", "changePasswordConstant","modalSvc","showPasswordChangeConfirmation"];
angular.module("iFAST.login")
    .constant("changePasswordConstant",{
        "JUSERNAME": "j_username",
        "JPASSWORD": "j_password",
        "NEWPASSWORD": "new_password",
        "CONFPASSWORD": "conf_password"
    })
    .controller("changePasswordCtrl", changePasswordCtrl);


// WEBPACK FOOTER //
// ./WebContent/src/login/changePwd-controller.js